import type React from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageState } from '../components/PageState';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	useTrackPageView();
	const { translate } = useI18n();

	return (
		<>
			{/* PageBanner on desktop only - on mobile it's inside parallax */}
			<div className="relative hidden md:block">
				<PageBanner />
			</div>

			<section
				aria-label={translate('corgi.psf.share.page_landmark')}
				// eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname
				className="bg-background-overlay min-h-screen w-full pb-16 md:pt-[50px]"
			>
				<PageState />
				<div className="mx-auto max-w-[610px]">
					<PageBody />
					<PageFooter />
				</div>
			</section>
		</>
	);
};
